/* 待办事项页面 */
<template>
  <lay-out>
    <Row class="mem-tabs" type="flex">
      <div
        v-for="(item, index) in tablist"
        :key="index"
        class="tab-item cursor"
        :class="activeTab === item.value ? ['active'] : ''"
        @click="handleTabChange(item)"
      >
        <span>{{ item.key }}</span>
      </div>
    </Row>
    <div class="my-todo">
      <div
        class="msg-item"
        v-if="msgList && msgList.length > 0"
        v-for="(item, index) in msgList"
        :key="index"
      >
        <div class="title">
          <Badge
            status="error"
            :class="item.isRead === 1 ? 'point-active' : ''"
            class="msg-badge"
            text
          />
          {{ item.title }}
          <span class="time">{{ item.createTime | date }}</span>
        </div>
        <Row type="flex" :style="{ marginTop: showImg ? '20px' : '0' }">
          <div class="content" :style="{ marginTop: showImg ? '16px' : '8px' }">
            <span class="wd">{{ item.content }}</span>
            <!-- 加入团队 -->
            <span
              v-if="item.type === 1"
              class="c-red cursor m-l-8"
              :class="{ staticlink: showImg }"
            >
              <router-link
                @click.native="clickIsReadr(item.id)"
                :to="`/invitation?key=${null}&projectId=${item.projectId}`"
                >查看详情</router-link
              >
            </span>

            <!-- 查看询价单 -->
            <span
              v-if="item.type === 2"
              class="c-red cursor m-l-8"
              :class="{ staticlink: showImg }"
            >
              <router-link
                @click.native="clickIsReadr(item.id)"
                :to="`/products/${item.projectId}`"
                >查看详情</router-link
              >
            </span>

            <!-- 订单查看详情 -->
            <span
              v-if="item.type === 3"
              class="c-red cursor m-l-8"
              :class="{ staticlink: showImg }"
            >
              <router-link
                @click.native="clickIsReadr(item.id)"
                :to="`/details/${item.resourceId}`"
                >查看详情</router-link
              >
            </span>
          </div>
        </Row>
      </div>
      <div
        style="margin-top:30px;"
        class="pages"
        v-if="msgList && msgList.length > 0"
      >
        <z-page
          :total="total || 0"
          :elevator="true"
          :pageSize="filter.pageSize"
          v-model="filter.pageNum"
        ></z-page>
      </div>
      <div class="align-center m-t-30 m-b-30" v-if="msgList.length == 0">
        <img src="@/assets/msg-empty.png" alt width="150px" />
      </div>
    </div>
  </lay-out>
</template>
<script>
import axios from 'axios'
import LayOut from './layout'

const VUE_APP_NEXT_BASIC_URL = process.env.VUE_APP_NEXT_BASIC_URL
const VUE_APP_OLD_BASIC_URL = process.env.VUE_APP_OLD_BASIC_URL
let filter = {
  pageSize: 20,
  pageNum: 1,
  status: 1,
}
export default {
  data() {
    return {
      busy: false,
      showImg: false,
      activeTab: 1,
      filter: filter,
      total: 0,
      tablist: [{ key: '待办事项', value: 1 }, { key: '已办事项', value: 2 }],
      msgList: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    /* 判断团队管理链接是否失效，失效直接跳转到失效页面 */
    axios
      .get(
        `/designer_api/user_td_item/list/v1?status=${filter.status}&pageSize=${
          filter.pageSize
        }&pageNum=${filter.pageNum}`,
        {
          globalLoading: true,
        }
      )
      .then((res) => {
        next((vm) => {
          vm.msgList = res.list
          vm.total = res.total
        })
      })
  },
  components: { LayOut },
  methods: {
    /* 标识是否已读 */
    clickIsReadr(id) {
      axios.put(`/designer_api/user_td_item/${id}`)
    },
    getLists() {
      /* 判断团队管理链接是否失效，失效直接跳转到失效页面 */
      axios
        .get(
          `/designer_api/user_td_item/list/v1?status=${
            this.activeTab
          }&pageSize=${this.filter.pageSize}&pageNum=${this.filter.pageNum}`,
          {
            globalLoading: true,
          }
        )
        .then((res) => {
          this.msgList = res.list
        })
    },
    handleTabChange(item) {
      if (this.busy || this.activeTab == item.value) {
        return false
      }
      this.activeTab = item.value
      this.getLists()
    },
  },
  watch: {
    'filter.pageNum': function() {
      this.getLists()
    },
  },
}
</script>

<style lang="scss">
.my-todo {
  background: #fff;
  padding: 30px;
  .msg-item {
    border: 1px solid #d2d2d2;
    padding: 20px 30px;
    margin-bottom: 20px;
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #4a4a4a;
      line-height: 14px;
      position: relative;
      .msg-badge {
        position: absolute;
        right: 100%;
        top: 0;
        margin-right: 10px;
        .ivu-badge-status-dot {
          width: 10px !important;
          height: 10px !important;
        }
      }
      .time {
        font-size: 12px;
        font-weight: 400;
        color: #4a4a4a;
        margin-left: 6px;
      }
    }
    .content {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: #4a4a4a;
      flex: 1;
      position: relative;
      margin-top: 8px;
      .wd {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        float: left;
      }
      .staticlink {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .cover {
      width: 324px;
      height: 194px;
      margin-right: 45px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .align-center {
    img {
      width: 250px;
    }
  }

  .point-active {
    .ivu-badge-status-error {
      background: #bfbfbf;
    }
  }
}
</style>
